import request from '@/utils/request'

export function fetchCurrent() {
    return request({
        url: '/v1/notifications/current',
        method: 'get',
    })
}
